import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Button,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useState } from "react";
import DownloadAppModal from "./DownloadApp";
import { motion } from "framer-motion";

const Hero = () => {
  const theme = useTheme();
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  return (
    <Box
      sx={{

        position: "relative",
        overflow: "hidden",
        pt: { xs: 8, md: 12 },
        pb: { xs: 4, md: 2 },

      }}
    >

      <Box
        sx={{
          position: "absolute",
          width: 500,
          height: 500,
          borderRadius: "50%",
          top: -150,
          right: -150,
          filter: "blur(120px)",
          zIndex: 0,
        }}
      />

      <Box
        sx={{
          position: "absolute",
          width: 600,
          height: 600,
          top: -200,
          left: -200,
          animation: "float 8s ease-in-out infinite",
          zIndex: 0,
          "@keyframes float": {
            "0%": { transform: "translateY(0px)" },
            "50%": { transform: "translateY(40px)" },
            "100%": { transform: "translateY(0px)" },
          },
        }}
      />

      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={6} alignItems="center">

          <Grid item xs={12} md={6}>
            <Typography
              sx={{
                fontSize: { xs: "20px", sm: "28px", md: "40px" },
                fontWeight: 600,
                lineHeight: 1.2,
                color: theme.palette.text.primary,
                mb: 3,
                mt: { xs: "18px", sm: "28px" },
                textAlign: "left"
                // background: { xs: "green", sm: "red", md: "blue" }
              }}
            >
              A{" "}
              <Box
                component="span"
                sx={{
                  background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                community-first wealth platform
              </Box>{" "}
              dedicated to serving the{" "}
              <Box
                component="span"
                sx={{
                  background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.text.primary})`,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                government & public sector employees
              </Box>
              .
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "12px", sm: "14px", md: "16px" },

                // color: theme.palette.text.secondary,
                color: "#333",
                // fontWeight: "500",
                mb: 4,



              }}
              data-aos="fade-up"

            >
              Smarter investments, Stronger insurance, Simpler banking— built with trust, clarity, and respect.
            </Typography>


          </Grid>

          <Grid item xs={12} md={6} textAlign="center">
            <motion.img
              src="https://ik.imagekit.io/arthgyan/Arthgyan_Web/%20Image%20png"
              alt="Hero"
              whileHover={{
                rotateX: 3,
                rotateY: -3,
                scale: 1.02,
              }}
              transition={{ type: "spring", stiffness: 200, damping: 15 }}
              style={{
                width: "100%",
                maxWidth: 820,
                // borderRadius: "12px",
                boxShadow: `0px 30px 60px ${theme.palette.primary.main}20`,
                transformStyle: "preserve-3d",
              }}
            />
            <Typography style={{ color: theme.palette.text.primary, fontWeight: 600, fontSize: "14px" }}>Because Those Who Serve The Nation Deserve The Best</Typography>
          </Grid>


        </Grid>
      </Container>
      <DownloadAppModal
        open={showDownloadModal}
        onClose={() => setShowDownloadModal(false)}
      />
    </Box>
  );
};

export default Hero;
